import React from 'react'

const formatDropdownData = (collectors, locale) =>
  collectors
    .map(c => ({ key: c.id, text: c.name, value: c.id }))
    .sort((a, b) => a.text.localeCompare(b.text, locale, { sensitivity: 'base' }))

export function useCollectorOptions(collectorsList, translate) {
  const locale = React.useMemo(
    () => (typeof navigator !== 'undefined' ? navigator.language : undefined),
    []
  )
  return React.useMemo(
    () =>
      Array.isArray(collectorsList) && collectorsList.length
        ? [
            { key: 'bookings_assigned_all', text: translate('ALL'), value: '' },
            ...formatDropdownData(collectorsList, locale),
          ]
        : [],
    [collectorsList, locale, translate]
  )
}
